<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title" id="tp"><a id="pagei"></a>Prizzi’s Honor</h1>
<p class="title1">Richard Condon</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795335020_tp.vue?6593d578